/** @return {string} - get dalenys token; */
const getDalenysToken = state => {
  return state.dalenysToken;
};

/** @return {string} - get tokenization error; */
const getTokenizationError = state => {
  return state.tokenizationError;
};

/** @return {array} - get payment methods; */
const getPaymentMethods = state => {
  return state.methods;
};

/** @return {object} - get choosen payment method; */
const getChoosenPaymentMethod = state => {
  return state.choosenMethod;
};

/** @return {object} - get hosted fields; */
const getHostedFields = state => {
  return state.hostedFields;
};

export default {
  getDalenysToken,
  getTokenizationError,
  getPaymentMethods,
  getChoosenPaymentMethod,
  getHostedFields,
};
